const MASTER_IDS_BY_TYPE = {
  master: (entry) => ({
    productId: entry._id || null,
    variantId: null,
  }),
  masterVariant: (entry) => ({
    productId: entry.baseProductId || null,
    variantId: entry._id || null,
  }),
  listing: (entry) => ({
    productId: entry.masterProductId || null,
    variantId: null,
  }),
  listingVariant: (entry) => ({
    productId: entry.masterProductId || null,
    variantId: entry.masterVariantId || null,
  }),
};

export default function getMasterIdsFromSelectionEntry(entry) {
  const readIds = MASTER_IDS_BY_TYPE[entry?.type];
  if (!readIds) return { productId: null, variantId: null };
  return readIds(entry);
}
